<template>
		<div>
				<h5>Welcome to PragmaPredict</h5>
				<small class="text-muted">Sign in with</small>
				<br><br>
				<a :href="login_link" class="btn btn-icon btn-rounded red text-white">
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 512">
							<path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" class=""></path>
						</svg>
					</span>
				</a>
				<div class="my-3 text-muted text-sm text-muted">
						OR
						<br><br>
						<h6>Sign Up</h6>
				</div>
				<div class="">
					<form name="form" @submit.prevent="register">
						<div class="form-group">
							<input type="text" class="form-control" v-model="username" placeholder="Username" required>
							<small v-if='field_errors.username' class="text-danger"> {{ field_errors.username }}</small>
						</div>
						<div class="form-group">
							<input type="email" class="form-control" v-model="email" placeholder="Email" required>
							<small v-if='field_errors.email' class="text-danger"> {{ field_errors.email }}</small>
						</div>
						<div class="form-group">
							<input type="password" class="form-control" v-model="password" placeholder="Password" required>
							<small v-if='field_errors.password' class="text-danger"> {{ field_errors.password }}</small>
						</div>
						<div class="mb-3 text-sm">
							<span class="text-muted">By clicking Sign Up, I agree to the</span>
							<a href="https://pragmapredict.com/terms-of-service/">Terms of service</a>
						</div>
						<button type="submit" class="btn btn-primary mb-4">Sign Up</button>
						<div>Already have an account?
							<router-link to="/login" tag="a">Sign In</router-link>
						</div>
					</form>
				</div>
		</div>
</template>


<script type="text/javascript">

import Vue from 'vue';
import {login_link } from '@/utils/auth';


export default{
	name: 'SignUp',
	data() {
		return {
			login_link: login_link,
			username: '',
			email: '',
			password: '',
			field_errors: {}
		}; 
	},

	methods: {
		register() {
			const path = process.env.API_LOCATION + "/send_confirmation_email";
			const params = {
				username: this.username,
				email: this.email,
				password: this.password
			}

			this.field_errors = {};

			this.$http.post(path, params)
			.then(() => {
				this.$router.push("/login/");
                this.$emit("success", "Confirmation email sent. Please check your inbox!");
			})
			.catch(error => {
				try {
					this.field_errors = error.response.data.errors;					
				} catch (error) {
					this.$emit("error", "Error while connecting server.");
				}
			});

		}
	},

}

</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue